import React from 'react';
import s from './Menu.scss';
import { useSettings } from '../../../../../providers/SettingsProvider';
import { useView, View } from '../../../../../providers/ViewProvider';
import { useGetPlaybackRateText } from '../SpeedSelector';
import { useTexts } from '../../../../../useTexts';
import classNames from 'classnames';
import { Arrow } from '../Arrow/Arrow';
const MenuItem = ({ title, value, onClick }) => {
    return (React.createElement("li", null,
        React.createElement("button", { className: s.button, onClick: onClick },
            React.createElement("span", { className: s.title }, title),
            React.createElement("span", { className: s.value }, value),
            React.createElement(Arrow, null))));
};
export const Menu = ({ visible }) => {
    const { playbackRate, config: { speedEnabled, onMenuClicked }, qualityState, subtitlesState, } = useSettings();
    const { setView } = useView();
    const getPlaybackRateText = useGetPlaybackRateText();
    const { menuSpeedTitle, menuQualityTitle, menuSubtitlesTitle, subtitlesOffLabel } = useTexts();
    const handleMenuClick = (view) => {
        setView(view);
        if (onMenuClicked) {
            onMenuClicked(view);
        }
    };
    const subtitlesValue = subtitlesState
        ? subtitlesState.enabled && subtitlesState.selectedValue
            ? subtitlesState.options.find((o) => o.value === subtitlesState.selectedValue)?.displayText ?? subtitlesOffLabel
            : subtitlesOffLabel
        : subtitlesOffLabel;
    return (React.createElement("ul", { className: classNames(s.list, {
            [s.visible]: visible,
        }) },
        speedEnabled ? (React.createElement(MenuItem, { title: menuSpeedTitle, value: getPlaybackRateText(playbackRate), onClick: () => handleMenuClick(View.Speed) })) : null,
        qualityState ? (React.createElement(MenuItem, { title: menuQualityTitle, value: qualityState.selectedQuality.name, onClick: () => handleMenuClick(View.Quality) })) : null,
        subtitlesState ? (React.createElement(MenuItem, { title: menuSubtitlesTitle, value: subtitlesValue, onClick: () => handleMenuClick(View.Subtitles) })) : null));
};
//# sourceMappingURL=Menu.js.map